import './TableRowCount.scss';

export interface ITableRowCountProps {
    /** undefined — загрузка или ошибка; не выдаём неизвестное количество за ноль. */
    count?: number;
    label?: string;
}

const TableRowCount = ({ count, label = 'стр.' }: ITableRowCountProps) => (
    <span className="table-row-count" aria-label={`Всего ${label}: ${count ?? 'неизвестно'}`}>
        {count === undefined ? '—' : count.toLocaleString('ru-RU')} {label}
    </span>
);

export default TableRowCount;
